import { maxLength } from "./validators";
import { invalidCharacters } from "utils/common";

const CREATIVE_NAME_PATTERN = /^[ ,a-zA-Z0-9_+/\\\-().:«»~ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ&!@#$%^*=|]+$/;
// CREATIVE_NAME_PATTERN plus [ ] ' " ? × } ` < { >, used when SUPPORT_LEGACY_INNOVID_SPECIAL_CHARS is enabled
const CREATIVE_NAME_PATTERN_LEGACY_INNOVID_CHARS = /^[ ,a-zA-Z0-9_+/\\\-().:«»~ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ&!@#$%^*=|\[\]'"?}`<{>]+$/;
export const CREATIVE_NAME_MAX_LENGTH = 500;
export const NATIVE_MAX = 500;
const VAST_URL_PATTERN = new RegExp("^https?://\S+\.\S+", "i");
const VAST_URL_MAX_LENGTH = 64000;
const YOUTUBE_URL_PATTERN = /^https:\/\/(www\.)?youtube\.com\/watch\?v=[A-Za-z0-9_-]{11}(&\S*)?$/;
const YOUTUBE_URL_ERROR_MESSAGE = "Field must be a full-length YouTube URL (e.g. https://www.youtube.com/watch?v=VIDEO_ID) — shortened youtu.be links are not supported";

export const CREATIVE_FILENAME_MAX_LENGTH = 250;

function allowedCharsValidator(pattern){
	return function(value){
		const invalidCharactersFunc = invalidCharacters(pattern, value);
		const NAME_ERROR_MESSAGE = `${invalidCharactersFunc.join(" ")} ${invalidCharactersFunc.length > 1 ? 'are' : 'is'} not permitted in creative names`;
		return invalidCharactersFunc.length ? NAME_ERROR_MESSAGE : undefined;
	};
}

export const creativeNameAllowedChars = allowedCharsValidator(CREATIVE_NAME_PATTERN);
export const creativeNameAllowedCharsLegacyInnovid = allowedCharsValidator(CREATIVE_NAME_PATTERN_LEGACY_INNOVID_CHARS);

export const creativeNameMaxLength = maxLength(CREATIVE_NAME_MAX_LENGTH);
export const creativeFilenameMaxLength = maxLength(CREATIVE_FILENAME_MAX_LENGTH);
export const nativeNameMaxLength = maxLength(NATIVE_MAX);

export function partnerVastURL(value){
	return VAST_URL_PATTERN.test(value);
}

export const partnerVastURLMax = maxLength(VAST_URL_MAX_LENGTH);

export function youtubeURL(value){
	if(!value){
		return undefined;
	}
	if(!YOUTUBE_URL_PATTERN.test(value)){
		return YOUTUBE_URL_ERROR_MESSAGE;
	}
	return undefined;
}
